import styled from "styled-components";

import { InlineHint } from "../../pages/Orcamentos/styles";
import { getToneTokens } from "../../styles/shared";

/** Largura mínima de uma coluna antes de a grade virar uma coluna só. */
const COLUNA_MINIMA = "160px";
const ESPACO = "12px";

/**
 * Grade de um endereço — responde à largura do CONTÊINER, não da janela.
 *
 * O `FormGrid` do design system é `1fr 1fr` e só vira uma coluna abaixo de
 * 640px de janela. Na coluna do cockpit do lead (~290px com a janela em
 * 1280px) as duas faixas não encolhiam abaixo do conteúdo dos inputs e do
 * select de UF, e o `overflow: hidden` do bloco cortava CEP, complemento e UF
 * (zero scroll lateral / nada cortado é regra do PharuERP).
 *
 * Aqui: no máximo duas colunas, cada uma com pelo menos metade da largura; e
 * uma coluna só quando a metade não chega a `COLUNA_MINIMA`. `min-width: 0`
 * nos filhos e `width: 100%` nos controles deixam tudo encolher até caber.
 */
export const GradeDoEndereco = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(min(100%, max(${COLUNA_MINIMA}, calc((100% - ${ESPACO}) / 2))), 1fr)
  );
  gap: ${ESPACO};
  min-width: 0;

  > * {
    min-width: 0;
  }

  > .full {
    grid-column: 1 / -1;
  }

  input,
  select {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
`;

/**
 * Dica curta embaixo de um campo. Sem `$tom`, é a dica neutra do design
 * system; com `$tom` ("danger" para erro, "warning" para a busca de CEP que
 * não achou ou caiu), usa a cor do estado — cor aqui só comunica estado.
 */
export const AvisoDoCampo = styled(InlineHint)`
  color: ${({ theme, $tom }) => ($tom ? getToneTokens(theme, $tom).text : theme.textTertiary)};
`;
